import moment from "moment";
import api from "./Api";
import { handleApiError } from "../utils/apiUtils";

const DashBoard = process.env.REACT_APP_DASHBOARD_URL || "";
const DashboardAPI = api(DashBoard);

export interface ApiResponse<T> {
  result: T;
  isSuccess: boolean;
  message: string;
  statusCode: number;
}

export interface AppointmentSummary {
  caseAppointmentId: number;
  appointmentType: string;
  appointmentValues_Scheduled: number;
  appointmentValues_Completed: number;
  appointmentValues_Cancelled: number;
  appointmentValues_OnTime?: number;
}

export const getRORRecentActivity = async (limit: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/ror/dashboard/recent-activity?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getRORRushNotesSummary = async (limit: any): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/ror/dashboard/latest-rush-notes?limit=${limit}`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

export const getRORCaseActionsSummary = async (
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/ror/dashboard/case-actions?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getRORWorkBreakDown = async (interval: any): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/ror/dashboard/workload-breakdown?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getRORPagesReviewed = async (
  limit: any,
  interval: any,
): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/ror/dashboard/pages-reviewed?topN=${limit}&interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getRORInvoiceOverview = async (interval: any): Promise<any[]> => {
  try {
    const response = await DashboardAPI.get(
      `/api/ror/dashboard/invoice-overview?interval=${interval}`,
    );
    return response.data?.result || [];
  } catch (error) {
    console.error("Error fetching case actions:", error);
    handleApiError(error);
    throw new Error("Unable to fetch case actions. Please try again later.");
  }
};

export const getAppointmentRORSummary = async (): Promise<
  AppointmentSummary[]
> => {
  try {
    const response = await DashboardAPI.get("/api/ror/dashboard/appointments");
    return response.data.result;
  } catch (error) {
    console.error("Error fetching appointment summary:", error);
    handleApiError(error);
    throw new Error(
      "Unable to fetch appointment summary. Please try again later.",
    );
  }
};

export const getRORAppointmentAnalyticsView = async (): Promise<any> => {
  try {
    const response = await DashboardAPI.get<ApiResponse<any>>(
      `/api/ror/dashboard/appointments/analytics`,
    );

    return response.data?.result;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
